export * from './ComparisonRegistrationTemplate';
